import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import config from './src/api/config';

export const app = initializeApp(config.firebaseConfig);

export const functions = getFunctions(app);
export const db = getFirestore(app);
